import {
  CvtTooltip
} from './CvtTooltip'
import {
  CvtPopper
} from './CvtPopper'
import {
  pluginFactory
} from '../../../lib/utils/plugins'
import Vue from '../../../lib/utils/vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const CvtTooltipPlugin = /*#__PURE__*/ pluginFactory({
  components: {
    CvtTooltip
  },
})

export {
  CvtTooltipPlugin,
  CvtTooltip,
  CvtPopper
}
